import React, { useMemo } from "react"
import { TrialSummary } from "trimble-terra"
import "./EntitlementsForm.scss"
import { CognitoFormComponent } from "../TrialWorkFlow/CognitoFormComponent"

const EntitlementsForm = ({
  trialSummary,
  cognitoForm,
  appData,
  userInfo,
  productData,
  prefillData,
  startTrial,
  setLoading,
  setError,
  setErrorText,
  loading,
}) => {
  return (
    <section className="entitlement-form-container">
      <div className="entitlement-form-container__content-area">
        <div className="trial-cognito">
          {cognitoForm?.header && (
            <h2 className="entitlement-form-container--header">
              {cognitoForm?.header}
            </h2>
          )}
          {cognitoForm?.description && (
            <p className="entitlement-form-container--description">
              {cognitoForm?.description}
            </p>
          )}
          <CognitoFormComponent
            formData={cognitoForm}
            prefillData={prefillData}
            setLoading={setLoading}
            setError={setError}
            setErrorText={setErrorText}
            loading={loading}
            startTrial={startTrial}
            productData={productData}
          />
        </div>

        {trialSummary && <TrialSummary content={trialSummary} />}
      </div>
    </section>
  )
}

export default EntitlementsForm
